import BaseNode from './BaseNode';
import LockIcon from '@mui/icons-material/Lock';
import { colors } from '../../styles';

const AuthNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Autenticação" accent={colors.brand.textSecondary} icon={<LockIcon />} />
);

export default AuthNode;
